import { useEffect, useState } from 'react'

import { api } from '../services/api.service'

import SettingsForm from '../forms/settings-form'

export default function Settings() {
    const [user, setUser] = useState(null)

    useEffect(() => {
        api(`${process.env.REACT_APP_API_URL}/app/get-current-user-details`).then((response) => {
            setUser(response.user)
        })
    }, [])

    const getSubscriptionDisplay = (type) => {
        switch (type) {
            case 'family_premium':
                return 'Family Plus'
            case 'standard_premium':
                return 'Plus'
            default:
                return 'Standard'
        }
    }

    return (
        <div className='space-y-6 mt-10'>
            {/* Subscription Settings Section */}
            <div className='bg-white rounded shadow p-5'>
                <div className='text-lg font-medium text-neutral-800 mb-4'>Subscription</div>
                {user && (
                    <div className='space-y-4'>
                        <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0'>
                            <div>
                                <div className='text-sm text-gray-600 mb-2'>Current Plan</div>
                                <span className={`inline-block px-3 py-1 text-sm font-semibold rounded-full ${user.subscriptionType === 'family_premium' ? 'bg-purple-100 text-purple-800' : user.subscriptionType === 'standard_premium' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`}>{getSubscriptionDisplay(user.subscriptionType)}</span>
                            </div>
                            <div className='flex-shrink-0'>
                                <a href='https://theboomerangtag.com/pages/manage-plus' target='_blank' rel='noopener noreferrer' className='inline-flex items-center justify-center w-full sm:w-auto px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brand-500 hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500'>
                                    Learn More or Manage Plus
                                </a>
                            </div>
                        </div>

                        {user.subscriptionType === 'standard' && (
                            <div className='p-4 bg-blue-50 border border-blue-200 rounded-md'>
                                <div className='flex items-start space-x-3'>
                                    <div className='flex-shrink-0'>
                                        <svg className='h-5 w-5 text-blue-400' viewBox='0 0 20 20' fill='currentColor'>
                                            <path fillRule='evenodd' d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z' clipRule='evenodd' />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className='text-sm font-medium text-blue-800'>Upgrade to Plus</h3>
                                        <div className='mt-1 text-sm text-blue-700'>
                                            <p>Get WhatsApp alerts, custom SMS messages to finders, multiple email and WhatsApp alerts, and more plus features!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Profile Settings Section */}
            <div className='bg-white rounded shadow p-5'>
                <div className='text-lg font-medium text-neutral-800 mb-4'>Profile Settings</div>
                <div className='text-neutral-700 text-center my-5'>
                    <div>Change your profile details and amend what is visible to finders at any time.</div>
                    <div>If you'd rather not leave your contact details, that's ok! Finders can still send you an email via Boomerang with return details.</div>
                    <div>For individual items, adjust what can be seen by clicking "manage" on the My BoomerangTag page.</div>
                </div>
                <SettingsForm />
            </div>
        </div>
    )
}
